import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const GeneralSettingsIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M6 9.5V8.5M10 9.5V7.5M14 9.5V5.5M8 13.5L6.5 17.5M13.828 17.4444L12.0602 13.5554M4 13.5C2.89543 13.5 2 12.6046 2 11.5V4.5C2 3.39543 2.89543 2.5 4 2.5H16C17.1046 2.5 18 3.39543 18 4.5V11.5C18 12.6046 17.1046 13.5 16 13.5H4Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

GeneralSettingsIcon.displayName = 'GeneralSettingsIcon';
